import * as React from "react";
import { forwardRef } from "react";
const SvgBlackFlag = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "0 0 16 16", ref, "aria-labelledby": titleId, ...props }, title === void 0 ? /* @__PURE__ */ React.createElement("title", { id: titleId }, "flag") : title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { fill: "#000000" }, /* @__PURE__ */ React.createElement("path", { fill: "#000000", d: "M15,1H3c0-0.6-0.4-1-1-1S1,0.4,1,1v14c0,0.6,0.4,1,1,1s1-0.4,1-1v-5h12V1z" })));
const ForwardRef = forwardRef(SvgBlackFlag);
export { ForwardRef as ReactComponent };
